import styled from "styled-components";

const Description = styled.p`
  width: 100%;
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 24}px;
  font-family: "Inter", sans-serif;
  color: ${({ theme }) => theme.THEME.white};
  text-align: start;
  margin-bottom: ${({ theme }) => theme.CONSTANTS.XH * 2}px;
  padding-left: ${({ theme }) => theme.CONSTANTS.XW * 10}px;

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 6}px;
  }
`;

export default Description;
